import { GameSDKPrivate } from './core'

export default new GameSDKPrivate()
